// Core pages
import TestDetail from '../features/tests/pages/TestDetail';
import TestEditor from '../features/tests/pages/TestEditor';
import Tests from '../features/tests/pages/Tests';

import Analytics from '../pages/Analytics';
import Campaigns from '../pages/Campaigns';
import Fintech from '../pages/Fintech';
import Inbox from '../pages/Inbox';
import Messages from '../pages/Messages';

// Authentication pages
import ResetPasswordPage from '../features/auth/pages/ResetPasswordPage';
import SigninPage from '../features/auth/pages/SigninPage';
import SignupPage from '../features/auth/pages/SignupPage';
import VerifyEmailPage from '../features/auth/pages/VerifyEmailPage';

// Settings page
import NotificationsPage from '../features/settings/pages/Notifications';
import SettingsPage from '../features/settings/pages/Settings';
import SubscriptionCancelConfirmPage from '../features/settings/pages/SubscriptionCancelConfirmPage';
import SubscriptionCancelPage from '../features/settings/pages/SubscriptionCancelPage';
import SubscriptionCancelSuccessPage from '../features/settings/pages/SubscriptionCancelSuccessPage';
import SubscriptionChangePage from '../features/settings/pages/SubscriptionChangePage';
import SubscriptionChangeSuccessPage from '../features/settings/pages/SubscriptionChangeSuccessPage';
import SubscriptionDowngradeToFreeConfirmPage from '../features/settings/pages/SubscriptionDowngradeToFreeConfirmPage';
import SubscriptionDowngradeToFreeSuccessPage from '../features/settings/pages/SubscriptionDowngradeToFreeSuccessPage';
import SubscriptionDowngradeToMonthlyConfirmPage from '../features/settings/pages/SubscriptionDowngradeToMonthlyConfirmPage';
import SubscriptionDowngradeToMonthlySuccessPage from '../features/settings/pages/SubscriptionDowngradeToMonthlySuccessPage';
import SubscriptionHistoryPage from '../features/settings/pages/SubscriptionHistoryPage';
import SubscriptionSuccessPage from '../features/settings/pages/SubscriptionSuccessPage';
import SubscriptionUpgradeToYearlyConfirmPage from '../features/settings/pages/SubscriptionUpgradeToYearlyConfirmPage';
import SubscriptionUpgradeToYearlySuccessPage from '../features/settings/pages/SubscriptionUpgradeToYearlySuccessPage';

// Utility pages
import Changelog from '../pages/utility/Changelog';
import EmptyState from '../pages/utility/EmptyState';
import Faqs from '../pages/utility/Faqs';
import Roadmap from '../pages/utility/Roadmap';

// Onboarding pages
import Onboarding01 from '../pages/Onboarding01';
import Onboarding02 from '../pages/Onboarding02';
import Onboarding03 from '../pages/Onboarding03';
import Onboarding04 from '../pages/Onboarding04';

// E-commerce pages
import Cart from '../pages/ecommerce/Cart';
import Cart2 from '../pages/ecommerce/Cart2';
import Cart3 from '../pages/ecommerce/Cart3';
import Customers from '../pages/ecommerce/Customers';
import Invoices from '../pages/ecommerce/Invoices';
import Orders from '../pages/ecommerce/Orders';
import Pay from '../pages/ecommerce/Pay';
import Product from '../pages/ecommerce/Product';
import Shop from '../pages/ecommerce/Shop';
import Shop2 from '../pages/ecommerce/Shop2';

import MessagesPage from '../features/messages/pages/Messages';

// Community pages
import Connections from '../features/community/pages/Connections';
import FeedPage from '../features/community/pages/Feed';
import Members from '../features/community/pages/Members';
import MyProfile from '../features/community/pages/MyProfile';
import PostDetail from '../features/community/pages/PostDetail';
import UserProfile from '../features/community/pages/UserProfile';
import Feed from '../pages/community/Feed';
import Forum from '../pages/community/Forum';
import ForumPost from '../pages/community/ForumPost';
import Meetups from '../pages/community/Meetups';
import MeetupsPost from '../pages/community/MeetupsPost';
import Profile from '../pages/community/Profile';
import UsersTabs from '../pages/community/UsersTabs';
import UsersTiles from '../pages/community/UsersTiles';

// Finance pages
import CreditCards from '../pages/finance/CreditCards';
import TransactionDetails from '../pages/finance/TransactionDetails';
import Transactions from '../pages/finance/Transactions';

// Job pages
import CompanyProfile from '../pages/job/CompanyProfile';
import JobListing from '../pages/job/JobListing';
import JobPost from '../pages/job/JobPost';

// Task pages

// Settings pages
import Account from '../pages/settings/Account';
import Apps from '../pages/settings/Apps';
import Billing from '../pages/settings/Billing';
import Feedback from '../pages/settings/Feedback';

// Component pages
import PlansPage from '@features/settings/pages/Plans';
import TasksPage from '@features/tasks/pages/TasksPage';
import DiagnosticTest from '@features/tests/pages/DiagnosticTest';
import PageNotFound from '@shared/utils/PageNotFound';
import PageNotFoundPublic from '@shared/utils/PageNotFoundPublic';
import Dashboard from '../features/dashboard/pages/Dashboard';
import StudyPlan from '../features/study-plan/pages/StudyPlan';
import SupportPage from '../features/support/pages/SupportPage';
import TestProcessing from '../features/tests/pages/TestProcessing';
import AccordionPage from '../pages/component/AccordionPage';
import AlertPage from '../pages/component/AlertPage';
import AvatarPage from '../pages/component/AvatarPage';
import BadgePage from '../pages/component/BadgePage';
import BreadcrumbPage from '../pages/component/BreadcrumbPage';
import ButtonPage from '../pages/component/ButtonPage';
import DropdownPage from '../pages/component/DropdownPage';
import FormPage from '../pages/component/FormPage';
import IconsPage from '../pages/component/IconsPage';
import ModalPage from '../pages/component/ModalPage';
import PaginationPage from '../pages/component/PaginationPage';
import TabsPage from '../pages/component/TabsPage';
import TooltipPage from '../pages/component/TooltipPage';

// Question Bank pages
import CategoryExplorer from '@features/question-bank/pages/CategoryExplorer';
import QuestionBankTestDetail from '@features/question-bank/pages/QuestionBankTestDetail';
import Categories from '../features/question-bank/pages/admin/Categories';
import QuestionBankItemEditor from '../features/question-bank/pages/admin/QuestionBankItemEditor';
import QuestionBankList from '../features/question-bank/pages/admin/QuestionBankList';

// Tutorial Bank pages
import TutorialBankCategoryDetail from '../features/tutorial-bank/pages/TutorialBankCategoryDetail';
import TutorialBankDetail from '../features/tutorial-bank/pages/TutorialBankDetail';
import TutorialCategoryExplorer from '../features/tutorial-bank/pages/TutorialCategoryExplorer';
import TutorialBankItemEditor from '../features/tutorial-bank/pages/admin/TutorialBankItemEditor';
import TutorialBankList from '../features/tutorial-bank/pages/admin/TutorialBankList';

// Tutor pages
import CalendarPage from '@features/calendar/pages/Calendar';
import TutorPage from '../features/tutor/pages/TutorPage';

// Route definitions
const routes = {
  public: [
    { path: '/signin', component: SigninPage },
    { path: '/signup', component: SignupPage },
    { path: '/reset-password', component: ResetPasswordPage },
    { path: '/verify-email', component: VerifyEmailPage },
    { path: '/404', component: PageNotFoundPublic },
  ],
  protected: [
    {
      path: '/',
      component: Dashboard,
    },
    { path: '/not-found', component: PageNotFound },
    {
      path: '/dashboard',
      children: [
        { path: 'analytics', component: Analytics },
        { path: 'fintech', component: Fintech },
      ],
    },
    {
      path: '/ecommerce',
      children: [
        { path: 'customers', component: Customers },
        { path: 'orders', component: Orders },
        { path: 'invoices', component: Invoices },
        { path: 'shop', component: Shop },
        { path: 'shop-2', component: Shop2 },
        { path: 'product', component: Product },
        { path: 'cart', component: Cart },
        { path: 'cart-2', component: Cart2 },
        { path: 'cart-3', component: Cart3 },
        { path: 'pay', component: Pay },
      ],
    },
    {
      path: '/community',
      children: [
        { path: 'connections', component: Connections },
        { path: 'profile2', component: Profile },
        { path: 'profile', component: MyProfile },
        { path: 'profile/:userId', component: UserProfile },
        { path: 'members', component: Members },
        { path: 'users-tabs', component: UsersTabs },
        { path: 'users-tiles', component: UsersTiles },
        { path: 'feed', component: FeedPage },
        { path: 'post/:id', component: PostDetail },
        { path: 'feed2', component: Feed },
        { path: 'forum', component: Forum },
        { path: 'forum-post', component: ForumPost },
        { path: 'meetups', component: Meetups },
        { path: 'meetups-post', component: MeetupsPost },
      ],
    },
    {
      path: '/finance',
      children: [
        { path: 'cards', component: CreditCards },
        { path: 'transactions', component: Transactions },
        { path: 'transaction-details', component: TransactionDetails },
      ],
    },
    {
      path: '/job',
      children: [
        { path: 'job-listing', component: JobListing },
        { path: 'job-post', component: JobPost },
        { path: 'company-profile', component: CompanyProfile },
      ],
    },
    {
      path: '/tasks',
      component: TasksPage,
    },
    {
      path: '/study-plan',
      children: [
        { path: '', component: StudyPlan },
        { path: ':testProgressId', component: StudyPlan },
      ],
    },
    {
      path: '/question-bank',
      children: [
        { path: 'admin/categories', component: Categories },
        { path: 'admin/list', component: QuestionBankList },
        { path: 'admin/edit/:itemId', component: QuestionBankItemEditor },
        { path: 'admin/create', component: QuestionBankItemEditor },
        { path: 'categories', component: CategoryExplorer },
        { path: 'test/:testId', component: QuestionBankTestDetail },
      ],
    },
    {
      path: '/tutorial-bank',
      children: [
        { path: '', component: TutorialCategoryExplorer },
        { path: 'admin/list', component: TutorialBankList },
        { path: 'admin/edit/:itemId', component: TutorialBankItemEditor },
        { path: 'admin/create', component: TutorialBankItemEditor },
        { path: 'category/:categoryId', component: TutorialBankCategoryDetail },
        { path: 'tutorial/:categoryId/:tutorialId', component: TutorialBankDetail },
      ],
    },
    {
      path: '/settings',
      children: [
        { path: 'account-old', component: Account },
        { path: 'account', component: SettingsPage },
        { path: 'notifications', component: NotificationsPage },
        { path: 'apps', component: Apps },
        { path: 'plans', component: PlansPage },
        { path: 'billing', component: Billing },
        { path: 'feedback', component: Feedback },
        { path: 'subscription-success', component: SubscriptionSuccessPage },
        { path: 'subscription-cancel', component: SubscriptionCancelPage },
        {
          path: 'subscription-change/:action/:subscriptionId',
          component: SubscriptionChangePage,
        },
        {
          path: 'subscription-cancel-confirm/:subscriptionId',
          component: SubscriptionCancelConfirmPage,
        },
        {
          path: 'subscription-downgrade-free-confirm/:subscriptionId',
          component: SubscriptionDowngradeToFreeConfirmPage,
        },
        {
          path: 'subscription-downgrade-monthly-confirm/:subscriptionId',
          component: SubscriptionDowngradeToMonthlyConfirmPage,
        },
        {
          path: 'subscription-change/cancel/success',
          component: SubscriptionCancelSuccessPage,
        },
        {
          path: 'subscription-change/downgrade-free/success',
          component: SubscriptionDowngradeToFreeSuccessPage,
        },
        {
          path: 'subscription-change/downgrade-monthly/success',
          component: SubscriptionDowngradeToMonthlySuccessPage,
        },
        {
          path: 'subscription-change/:action/success',
          component: SubscriptionChangeSuccessPage,
        },
        { path: 'subscription-history', component: SubscriptionHistoryPage },
        {
          path: 'subscription-upgrade-yearly-confirm/:subscriptionId',
          component: SubscriptionUpgradeToYearlyConfirmPage,
        },
        {
          path: 'subscription-upgrade-yearly/success',
          component: SubscriptionUpgradeToYearlySuccessPage,
        },
      ],
    },
    {
      path: '/utility',
      children: [
        { path: 'changelog', component: Changelog },
        { path: 'roadmap', component: Roadmap },
        { path: 'faqs', component: Faqs },
        { path: 'empty-state', component: EmptyState },
      ],
    },
    {
      path: '/component',
      children: [
        { path: 'button', component: ButtonPage },
        { path: 'form', component: FormPage },
        { path: 'dropdown', component: DropdownPage },
        { path: 'alert', component: AlertPage },
        { path: 'modal', component: ModalPage },
        { path: 'pagination', component: PaginationPage },
        { path: 'tabs', component: TabsPage },
        { path: 'breadcrumb', component: BreadcrumbPage },
        { path: 'badge', component: BadgePage },
        { path: 'avatar', component: AvatarPage },
        { path: 'tooltip', component: TooltipPage },
        { path: 'accordion', component: AccordionPage },
        { path: 'icons', component: IconsPage },
      ],
    },
    {
      path: '/tests',
      children: [
        { path: '', component: Tests },
        { path: ':testId/take', component: TestDetail },
      ],
    },
    {
      path: '/diagnostic-test',
      children: [
        { path: '', component: DiagnosticTest },
        { path: ':testId/take', component: TestDetail },
      ],
    },
    {
      path: '/test-processing',
      children: [
        { path: '', component: TestProcessing },
        { path: ':testId/edit', component: TestEditor },
      ],
    },
    {
      path: '/tutor',
      children: [
        { path: '', component: TutorPage },
        { path: ':conversationId', component: TutorPage },
      ],
    },
    // Core routes
    { path: '/calendar', component: CalendarPage },
    { path: '/messages', component: MessagesPage },
    { path: '/support', component: SupportPage },
    { path: '/messages2', component: Messages },
    { path: '/inbox', component: Inbox },
    { path: '/campaigns', component: Campaigns },
  ],
  onboarding: [
    { path: '/onboarding-01', component: Onboarding01 },
    { path: '/onboarding-02', component: Onboarding02 },
    { path: '/onboarding-03', component: Onboarding03 },
    { path: '/onboarding-04', component: Onboarding04 },
  ],
};

export default routes;
